/*
 * Copyright (c) 2021-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: ChangelogOverlay.tsx
 * Project: mle-client-n
 * Committed last: 2022/2/4 @ 1517
 * ---
 * Description:
 */

import {
  Button,
  Card,
  Classes,
  Icon,
  Intent,
  Overlay,
  Spinner,
  Tag
}                                     from '@blueprintjs/core';
import classNames                     from 'classnames';
import { currentThemeIsDark }         from '../../../common/utils';
import { CenterBothAxes }             from '../layout/CenterBothAxes';
import React, { useEffect, useState } from 'react';
import { OctokitProvider }            from '../../../common/octokit-provider';
import { Converter }                  from 'showdown';
import * as config                    from '../../../config/defaults.json';

export const ChangelogOverlay = (props: { handleClose: () => void, isOpen: boolean }) => {
  const [ isLoading, setIsLoading ] = useState(false);
  const [ releases, setReleases ] = useState<any>();
  const [ latest, setLatest ] = useState<any>();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const releasesResponse = await OctokitProvider.getInstance().rest.repos.listReleases(
        {
          owner: config.octoKit.clientOrg,
          repo: config.octoKit.clientRepo
        });
      setReleases(releasesResponse.data);

      const latestRestponse = await OctokitProvider.getInstance().rest.repos.getLatestRelease(
        {
          owner: config.octoKit.clientOrg,
          repo: config.octoKit.clientRepo
        });
      setLatest(latestRestponse.data);
      setIsLoading(false);
    })();
  }, [ props.isOpen ]);

  const releasesContent = () => {
    const converter = new Converter();
    return releases?.map((release: any) => <Card key={ release.tag_name }
                                                 className="my-3  bg-white bg-opacity-5">
        <div className={ classNames('mx-0 mt-0 mb-3 p-2 rounded', {
          'bg-bplight-500 bg-opacity-10': currentThemeIsDark(),
          'bg-bpdisabled-light': !currentThemeIsDark()
        }) }>
          <div className="bp4-running-text mb-1">
            <code>{ release.tag_name }</code>
            {
              release.prerelease &&
              <Tag
                className="ml-1"
                minimal
                intent={ Intent.WARNING }
              >Pre-release</Tag>
            }
            {
              release.tag_name === latest.tag_name &&
              <Tag
                className="ml-1"
                minimal
                intent={ Intent.SUCCESS }
              >Ultimo rilascio</Tag>
            }
          </div>
          <div>
            <h5 className="bp4-heading">{ release.name }</h5>
          </div>
          <div className="bp4-text-muted">
            <Icon
              icon="calendar"/> { new Date(release.published_at).toLocaleDateString(
            'it-IT') }
          </div>
        </div>
        <div
          className="bp4-running-text list-disc"
          dangerouslySetInnerHTML={ {
            __html: converter.makeHtml(release.body).replaceAll('<ul>',
              '<ul class="list-disc">')
          } }
        />
      </Card>
    );
  };

  return <Overlay
    onClose={ props.handleClose }
    usePortal
    enforceFocus
    canEscapeKeyClose
    canOutsideClickClose
    isOpen={ props.isOpen }
    className={ classNames(Classes.OVERLAY_CONTAINER,
      { 'bp4-dark': currentThemeIsDark() }) }
  >
    <CenterBothAxes>
      <Card
        className="mle-center-both-axes-child max-h-screen my-40 mx-auto max-w-3xl overflow-auto">
        <h5 className="bp4-heading">Changelog <div><small
          className="bp4-text-muted">Scorri
          per consultare tutti i rilasci <Icon icon="arrow-down"/></small>
        </div>
        </h5>
        <div className="flex flex-col">
          <div style={ { height: '35rem' } }
               className="relative flex flex-col overflow-y-auto">
            {
              isLoading ? <Spinner className="mt-10" size={ 20 }/>
                        : releasesContent()
            }
          </div>
        </div>
        <div className="mt-auto flex flex-row justify-end">
          <div className="mle-form-submit mt-2">
            <Button onClick={ props.handleClose }>Chiudi</Button>
          </div>
        </div>
      </Card>
    </CenterBothAxes>
  </Overlay>;
};




